exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-font[data-v-f0beec66]{line-height:30px;font-size:32px}@media (max-width: 991px){.price-font[data-v-f0beec66]{font-size:30px}}.price-original[data-v-f0beec66]{text-decoration:line-through}.custom-margines[data-v-f0beec66]{margin-top:10px}@media (max-width: 767px){.custom-margines[data-v-f0beec66]{margin-top:5px}}@media (max-width: 767px){.price[data-v-f0beec66]{color:#707070}}.original-price[data-v-f0beec66]{display:block;color:#707070;text-decoration:line-through;font-weight:400;font-size:18px}\n", ""]);

// exports
